/* tslint:disable:no-unused-variable */
import { Component, OnInit, HostBinding, Injectable } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from './reducers';
import { Notification } from './interfaces';
import { TealiumUtagService } from './tealium/utag.service';
import * as newsActions from './actions/news.actions';

@Component({
  selector: 'edge-app',
  template: `
    <router-outlet></router-outlet>
    <edge-notifications-container
      [notifications]="notifications$ | async"
    ></edge-notifications-container>
    <edge-mobile-menu [class.menu-open]="isOpen$ | async"></edge-mobile-menu>
  `,
  styleUrls: ['./app.component.scss'],
  providers: [TealiumUtagService]
})
export class AppComponent implements OnInit {
  @HostBinding('class') appClass: string = '';
  isOpen$: Observable<boolean>;
  notifications$: any = this.store.select(fromRoot.notifications);
  setConfig: any;

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private tealium: TealiumUtagService
  ) {
    this.isOpen$ = store.select(fromRoot.isOpen);
    this.tealium.setConfig({
      account: 'goarmy',
      profile: 'redstone',
      environment: 'prod'
    });

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        switch (event.url) {
          case '/':
            this.tealium.view({
              page_type: 'init'
            });
            break;

          case '/football':
            this.tealium.view({
              tealium_event: 'football_view',
              page_type: 'football'
            });
            break;

          case '/soccer':
            this.tealium.view({
              tealium_event: 'soccer_view',
              page_type: 'soccer'
            });
            break;

          case '/support/football':
            this.tealium.view({
              tealium_event: 'support_football_view',
              page_type: 'support'
            });
            break;

          case '/support/soccer':
            this.tealium.view({
              tealium_event: 'support_soccer_view',
              page_type: 'support'
            });
            break;

          case '/press':
            this.tealium.view({
              tealium_event: 'press_view',
              page_type: 'press'
            });
            break;

          case '/privacy-policy':
            this.tealium.view({
              tealium_event: 'privacy_policy_view',
              page_type: 'privacy'
            });
            break;

          case '/terms-of-use':
            this.tealium.view({
              tealium_event: 'terms_of_use_view',
              page_type: 'terms'
            });
            break;

          case '/eula':
            this.tealium.view({
              tealium_event: 'eula_view',
              page_type: 'eula'
            });
            break;

          default:
            break;
        }
      }
    });
  }

  ngOnInit(): void {
    this.isOpen$.subscribe((open) => {
      this.appClass = open ? 'menu-open' : '';
    });

    this.store.dispatch(newsActions.GetSocialMediaLinks());
  }
}
